import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Cryptos from "./pages/Cryptos";
import CryptoDetail from "./pages/CryptoDetail";
import Layout from "./components/Layout/Layout";
import News from "./pages/News";
import Chart from "./pages/Chart";

const App = () => {
  
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="cryptos" element={<Cryptos />} />
        <Route path="cryptos/:cryptoTicker" element={<CryptoDetail />} />
        <Route path="cryptos/chart/:coinId" element={<Chart />} />
        <Route path="news" element={<News />} />
      </Routes>
    </Layout>
  );
};

export default App;
